import React from "react";
import InputField from "../../components/InputField";
import Switch from "../../components/Switch";
import { format, parseISO } from "date-fns";

const AgreementForm = ({
  agreement,
  agreementPublicId,
  createdBy,
  createdDateTimeUTC,
  updatedBy,
  updatedDateTimeUTC,
  comment,
  setAgreement,
  setHasChanges,
  disabled,
}) => {
  
  const formatDate = (date) => {
    if (!date) return "";
    try {
      return format(parseISO(date), "yyyy-MM-dd");
    } catch (error) {
      return date; 
    }
  };
  
  return (
    <>
      {/* Two-column layout */}
      <div className="grid grid-cols-2 gap-6 w-full">
        {/* Column 1 */}
        <div className="flex flex-col gap-4">
          <InputField
            label="Agreement name"
            placeholder="Agreement name"
            value={agreement?.name || ""}
            onChange={(e) => {
              setAgreement((s) => ({ ...s, name: e.target?.value }));
              setHasChanges(true);
            }}
            className="w-full"
            disabled={disabled}
          />

          <InputField
            label="Agreement ID"
            placeholder="Agreement ID"
            value={agreement?.agreementPublicId || ""}
            onChange={(e) => {
              setAgreement((s) => ({
                ...s,
                agreementPublicId: {
                  ...agreementPublicId,
                  name: e.target?.value,
                },
              }));
              setHasChanges(true);
            }}
            className="w-full"
            disabled={disabled}
          />

          <InputField
            label="Comment"
            placeholder="Comment"
            value={agreement?.comment || "Unassigned"}
            onChange={(e) => {
              setAgreement((s) => ({
                ...s,
                comment: { ...comment, name: e.target?.value },
              }));
              setHasChanges(true);
            }}
            className="w-full"
            disabled={disabled}
          />
        </div>

        {/* Column 2 */}
        <div className="flex flex-col gap-4">

          <InputField
            label="Created by"
            placeholder="Created by"
            value={agreement?.createdBy || "Unassigned"}
            onChange={(e) => {
              setAgreement((s) => ({
                ...s,
                createdBy: { ...createdBy, name: e.target?.value },
              }));
              setHasChanges(true);
            }}
            className="w-full"
            disabled={disabled}
          />

          <InputField
            label="Created date"
            placeholder="Created date"
            value={formatDate(agreement?.createdDateTimeUTC) || "Unassigned"}
            onChange={(e) => {
              setAgreement((s) => ({
                ...s,
                createdDateTimeUTC: {
                  ...createdDateTimeUTC,
                  name: e.target?.value,
                },
              }));
              setHasChanges(true);
            }}
            className="w-full"
            disabled={disabled}
          />

          <InputField
            label="Updated by"
            placeholder="Updated by"
            value={agreement?.updatedBy || "Unassigned"}
            onChange={(e) => {
              setAgreement((s) => ({
                ...s,
                updatedBy: { ...updatedBy, name: e.target?.value },
              }));
              setHasChanges(true);
            }}
            className="w-full"
            disabled={disabled}
          />

          <InputField
            label="Updated date"
            placeholder="Updated date"
            value={formatDate(agreement?.updatedDateTimeUTC) || "Unassigned"}
            onChange={(e) => {
              setAgreement((s) => ({
                ...s,
                updatedDateTimeUTC: {
                  ...updatedDateTimeUTC,
                  name: e.target?.value,
                },
              }));
              setHasChanges(true);
            }}
            className="w-full"
            disabled={disabled}
          />

          <div className="flex flex-col w-1/2">
            <label className="text-sm font-bold pb-2">Status</label>
            <div className="flex items-center space-x-2">
              <Switch
                checked={agreement?.status === "active"}
                onChange={(checked) => {
                  setAgreement((s) => ({
                    ...s,
                    status: checked ? "active" : "inactive",
                  }));
                  setHasChanges(true);
                }}
                disabled={disabled}
              />
              <p className="text-sm">
                {agreement?.status === "active" ? "Active" : "Inactive"}
              </p>
            </div>
          </div>

        </div>
      </div>
    </>
  );
};

export default AgreementForm;
